import { Grid } from '@mui/material';
import { useState } from 'react';
import { Organization, RoleManagement, Meeting } from '@/icons';
import { ExportBtn } from '@/apps/core/elements/Buttons';

export const CommonButtons = ({ isSmallScreen, handleuserPopup, userSelected }: any) => {
  const [hover, setHover] = useState('');
  return (
    <Grid container display={'flex'} justifyContent={'center'} flexWrap={"nowrap"}>
      <Grid onMouseOver={() => setHover('ORG')} onMouseLeave={() => setHover('')} ml={'15px'}>
        <ExportBtn
          boxShadow={'0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px -2px 4px 0px rgba(0, 0, 0, 0.05)'}
          background={'#E0E9FA'}
          startIcon={<Organization width={20} fill={hover == 'ORG' ? '#3D79F2' : ''} />}
          onClick={() => handleuserPopup('Organizations', [])}
          children={'Add to Organization'}
          color={'#3D79F2'}
          className='add-user-top-btns-org'
        />
      </Grid>
      <Grid onMouseOver={() => setHover('ROLE')} onMouseLeave={() => setHover('')} ml={'15px'}>
        <ExportBtn
          boxShadow={'0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px -2px 4px 0px rgba(0, 0, 0, 0.05)'}
          background={'#F0FFF2'}
          startIcon={<RoleManagement width={24} height={24} fill={hover == 'ROLE' ? '#1F992F' : ''} />}
          onClick={() => handleuserPopup('Roles', [])}
          children={'Assign Role'}
          color={'#1F992F'}
          className='add-user-top-btns-role'
        />
      </Grid>
      <Grid onMouseOver={() => setHover('GROUP')} onMouseLeave={() => setHover('')} ml={'15px'}>
        <ExportBtn
          boxShadow={'0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px -2px 4px 0px rgba(0, 0, 0, 0.05)'}
          background={'var(--secondary-050, #E9DFF2)'}
          startIcon={<Meeting width={20} height={20} fill={hover == 'GROUP' ? '#864CBF' : ''} />}
          onClick={() => handleuserPopup('Groups', [])}
          children={'Add to Group'}
          color={'#864CBF'}
          className='add-user-top-btns-group'
        />
      </Grid>
    </Grid>
  );
};
